var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.show
        ? _c("core-popup", {
            ref: "corePopup",
            attrs: {
              title: !!_vm.settingsSync
                ? _vm.locale(
                    _vm.integrationName + "_integration_settings_up_header"
                  )
                : _vm.locale(_vm.integrationName + "_integration_popup_header"),
              show: _vm.show,
              width: 540,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c("div", { staticClass: "content" }, [
                        _vm.syncError.isShow
                          ? _c(
                              "div",
                              { class: _vm.$.integration_warning_message },
                              [
                                _c(
                                  "div",
                                  {
                                    class:
                                      _vm.$.integration_warning_message_icon,
                                  },
                                  [
                                    _c("svg-sprite", {
                                      attrs: {
                                        name: "warning-1",
                                        size: 20,
                                        type: "bold",
                                        color: "#FF9A00",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    class:
                                      _vm.$.integration_warning_message_text,
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.locale(_vm.syncError.message)
                                        ) +
                                        "\n          "
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { class: _vm.$.options },
                          _vm._l(_vm.options, function (option) {
                            return _c(
                              "div",
                              { class: _vm.$.radioOption },
                              [
                                _c("vgp-radio-button", {
                                  attrs: {
                                    checked: option.selected,
                                    label: _vm.locale(
                                      "integration_option_" + option.id
                                    ),
                                  },
                                  on: {
                                    onChange: function ($event) {
                                      return _vm.selectOption($event, option)
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                option.info
                                  ? _c(
                                      "div",
                                      { class: _vm.$.labelWrapper },
                                      [
                                        _c("tooltip", {
                                          attrs: {
                                            content: _vm.locale(
                                              "integration_option_" +
                                                option.info +
                                                "_desc"
                                            ),
                                            position: "right",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "body",
                                                fn: function () {
                                                  return [
                                                    _c("svg-sprite", {
                                                      attrs: {
                                                        color: "#B2B2B2",
                                                        name: "info",
                                                        size: 20,
                                                      },
                                                    }),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { class: _vm.$.sync_dropdowns_container },
                          [
                            _c("vgp-label-slot", {
                              class: _vm.$.sync_dropdown,
                              attrs: {
                                label:
                                  _vm.locale(
                                    "integration_project_to_sync_label"
                                  ) + " *",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "body",
                                    fn: function () {
                                      return [
                                        _c("dropdown-select", {
                                          attrs: {
                                            "drop-list": _vm.projects,
                                            placeholder: _vm.locale(
                                              "integration_project_dropdown_placeholder"
                                            ),
                                            "no-matches-message": _vm.locale(
                                              "integration_project_dropdown_no_matches"
                                            ),
                                            selected: _vm.selectedProject,
                                            multiselect: false,
                                            "use-search": true,
                                            "track-by": "id",
                                            "item-template": "text",
                                            "track-by-text": "name",
                                            "show-selected-first": true,
                                            "show-reset-btn": true,
                                            disabled:
                                              _vm.disabledElements.projectDrop,
                                          },
                                          on: {
                                            change: _vm.onChangeProjectSelected,
                                          },
                                        }),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                3957299727
                              ),
                            }),
                            _vm._v(" "),
                            _c("vgp-label-slot", {
                              class: [
                                _vm.$.sync_dropdown,
                                _vm.$.sync_dropdown_last,
                              ],
                              attrs: {
                                label:
                                  _vm.locale("integration_sync_options_label") +
                                  " *",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "body",
                                    fn: function () {
                                      return [
                                        _c("dropdown-select", {
                                          class: _vm.$.sync_dropdown_custom,
                                          attrs: {
                                            "drop-list": _vm.syncOptions,
                                            placeholder: _vm.locale(
                                              "integration_sync_options_dropdown_placeholder"
                                            ),
                                            selected: _vm.selectedSyncOption,
                                            multiselect: false,
                                            "use-search": false,
                                            "track-by": "id",
                                            "track-by-text": "name",
                                            "show-selected-first": false,
                                            "show-reset-btn": false,
                                            "item-template": "withIcon",
                                            disabled:
                                              _vm.disabledElements.syncDrop,
                                            "track-by-additional-for-item":
                                              "advanced",
                                          },
                                          on: {
                                            change: _vm.onChangeSyncSelected,
                                          },
                                        }),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                2882691519
                              ),
                            }),
                            _vm._v(" "),
                            _vm.selectedSyncOption &&
                            (_vm.selectedSyncOption.id === "assigned_to_me" ||
                              _vm.selectedSyncOption.id ===
                                _vm.assignedAndMilestones)
                              ? _c(
                                  "div",
                                  { class: _vm.$.switch_item },
                                  [
                                    _c("vgp-checkbox", {
                                      style: _vm.disabledElements
                                        .toggleMilestones
                                        ? { opacity: "0.5" }
                                        : {},
                                      attrs: {
                                        size: "16",
                                        checked: _vm.toggleOn,
                                        "is-disabled":
                                          _vm.disabledElements.toggleMilestones,
                                        "label-position": "right",
                                        label: _vm.locale(
                                          "integration_switch_to_milestones"
                                        ),
                                      },
                                      on: {
                                        onChange: function () {
                                          _vm.disabledElements.toggleMilestones
                                            ? null
                                            : _vm.activateElement()
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { class: [_vm.$.filter] }, [
                              _c("div", { class: [_vm.$.filter_title] }, [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.locale("integration_filter_title")
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div"),
                              ]),
                              _vm._v(" "),
                              _c("div", { class: [_vm.$.filter_row] }, [
                                _c(
                                  "div",
                                  [
                                    _c("vgp-label-slot", {
                                      class: _vm.$.sync_dropdown,
                                      attrs: {
                                        label:
                                          _vm.filterStaticItems.status.label,
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "body",
                                            fn: function () {
                                              return [
                                                _c("dropdown-select", {
                                                  attrs: {
                                                    "drop-list":
                                                      _vm.statusOptions,
                                                    placeholder:
                                                      _vm.filterStaticItems
                                                        .status.placeholder,
                                                    "no-matches-message":
                                                      _vm.locale(
                                                        "integration_project_status_no_matches"
                                                      ),
                                                    selected:
                                                      _vm.selectedStatus,
                                                    multiselect: true,
                                                    "item-template": "withIcon",
                                                    "track-by-text": "value",
                                                    "track-by-icon-name":
                                                      "icon",
                                                    "track-by-bg-color":
                                                      "color",
                                                    "show-selected-first": false,
                                                    "show-reset-btn": true,
                                                    disabled:
                                                      _vm.checkDisabledElements,
                                                  },
                                                  on: {
                                                    change: _vm.onChangeStatus,
                                                  },
                                                }),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        598298763
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  [
                                    _c("vgp-label-slot", {
                                      class: _vm.$.sync_dropdown,
                                      attrs: {
                                        label:
                                          _vm.filterStaticItems.priority.label,
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "body",
                                            fn: function () {
                                              return [
                                                _c("dropdown-select", {
                                                  attrs: {
                                                    "drop-list":
                                                      _vm.priorityOptions,
                                                    placeholder:
                                                      _vm.filterStaticItems
                                                        .priority.placeholder,
                                                    "no-matches-message":
                                                      _vm.locale(
                                                        "integration_project_priority_no_matches"
                                                      ),
                                                    selected:
                                                      _vm.selectedPriority,
                                                    multiselect: true,
                                                    "item-template": "withIcon",
                                                    "track-by-text": "value",
                                                    "track-by-icon-name":
                                                      "icon",
                                                    "track-by-bg-color":
                                                      "color",
                                                    "show-selected-first": false,
                                                    "show-reset-btn": true,
                                                    disabled:
                                                      _vm.checkDisabledElements,
                                                  },
                                                  on: {
                                                    change:
                                                      _vm.onChangePriority,
                                                  },
                                                }),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        51429133
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { class: [_vm.$.filter_row] }, [
                                _c(
                                  "div",
                                  [
                                    _c("vgp-label-slot", {
                                      class: [_vm.$.sync_dropdown],
                                      attrs: {
                                        label:
                                          _vm.filterStaticItems.startDate.label,
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "body",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    class: [
                                                      _vm.$.input,
                                                      _vm.readonly
                                                        ? _vm.$
                                                            .input_without_padding
                                                        : "",
                                                    ],
                                                    on: {
                                                      click: function () {
                                                        return !_vm.checkDisabledElements
                                                          ? _vm.showDateRangePicker(
                                                              "startDate"
                                                            )
                                                          : null
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("vgp-input", {
                                                      ref: "startDate",
                                                      attrs: {
                                                        placeholder:
                                                          _vm.filterStaticItems
                                                            .startDate
                                                            .placeholder,
                                                        readonly: false,
                                                        "disabled-input-only": true,
                                                        value:
                                                          _vm.startDatesValues,
                                                        small: true,
                                                        "is-disabled":
                                                          _vm.checkDisabledElements,
                                                        "icons-right":
                                                          _vm.setStartDateIcons,
                                                      },
                                                      on: {
                                                        input:
                                                          _vm.onChangeStartDate,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        3872476255
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  [
                                    _c("vgp-label-slot", {
                                      class: [_vm.$.sync_dropdown],
                                      attrs: {
                                        label:
                                          _vm.filterStaticItems.endDate.label,
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "body",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    class: [
                                                      _vm.$.input,
                                                      _vm.readonly
                                                        ? _vm.$
                                                            .input_without_padding
                                                        : "",
                                                    ],
                                                    on: {
                                                      click: function () {
                                                        return !_vm.checkDisabledElements &&
                                                          !_vm.startDateAndMilestoneCheck
                                                          ? _vm.showDateRangePicker(
                                                              "endDate"
                                                            )
                                                          : null
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("vgp-input", {
                                                      ref: "endDate",
                                                      attrs: {
                                                        placeholder:
                                                          _vm.filterStaticItems
                                                            .endDate
                                                            .placeholder,
                                                        readonly: false,
                                                        "disabled-input-only": true,
                                                        "is-disabled":
                                                          _vm.startDateAndMilestoneCheck ||
                                                          _vm.checkDisabledElements,
                                                        value:
                                                          _vm.endDatesValues,
                                                        small: true,
                                                        "icons-right":
                                                          _vm.setEndDateIcons,
                                                      },
                                                      on: {
                                                        input:
                                                          _vm.onChangeEndDate,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        554141982
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { class: [_vm.$.filter_row] }, [
                                _c(
                                  "div",
                                  [
                                    _c("vgp-label-slot", {
                                      class: _vm.$.sync_dropdown,
                                      attrs: {
                                        label:
                                          _vm.filterStaticItems.assignee.label,
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "body",
                                            fn: function () {
                                              return [
                                                _c("dropdown-select", {
                                                  attrs: {
                                                    "drop-list":
                                                      _vm.assigneeOptions,
                                                    placeholder:
                                                      _vm.filterStaticItems
                                                        .assignee.placeholder,
                                                    "no-matches-message":
                                                      _vm.locale(
                                                        "integration_project_assignee_no_matches"
                                                      ),
                                                    selected:
                                                      _vm.selectedAssignee,
                                                    multiselect: true,
                                                    "use-select-all": true,
                                                    "use-search": true,
                                                    "track-by": "id",
                                                    "item-template": "user",
                                                    "track-by-text": "name",
                                                    "show-selected-first": true,
                                                    "show-reset-btn": true,
                                                    disabled:
                                                      _vm.disabledElements
                                                        .assignee ||
                                                      _vm.checkDisabledElements,
                                                    "group-by": "group",
                                                  },
                                                  on: {
                                                    change:
                                                      _vm.onChangeAssignee,
                                                  },
                                                }),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        2149874041
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { class: _vm.$.action_buttons },
                              [
                                _c("vgp-button", {
                                  attrs: {
                                    type: "secondary",
                                    label: _vm.locale("common_cancel"),
                                    width: "90px",
                                    small: "",
                                  },
                                  on: { onClick: _vm.handleCancel },
                                }),
                                _vm._v(" "),
                                _c("vgp-button", {
                                  class: _vm.$.action_btn,
                                  attrs: {
                                    type: "primary",
                                    label: _vm.settingsSync
                                      ? _vm.locale("common_save")
                                      : _vm.locale("integration_create"),
                                    disabled: _vm.disabledElements.sendButton,
                                    width: "90px",
                                    small: "",
                                  },
                                  on: { onClick: _vm.handleCreateOrUpdate },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.isShowDateRange
                          ? _c(
                              "div",
                              [
                                _c("vgp-date-range-picker", {
                                  directives: [
                                    {
                                      name: "click-outside",
                                      rawName: "v-click-outside",
                                      value: _vm.clickOutsideDateRange,
                                      expression: "clickOutsideDateRange",
                                    },
                                  ],
                                  class: ["filter_item_date"],
                                  attrs: {
                                    show: _vm.isShowDateRange,
                                    "show-date-range-presets": false,
                                    "range-data":
                                      _vm.dateRangeType === "startDate"
                                        ? _vm.startDate
                                        : _vm.endDate,
                                    "min-date": _vm.setMinDate,
                                    "max-date": _vm.setMaxDate,
                                    "parent-element": _vm.dateRangeTargetParent,
                                    "target-element": _vm.dateRangeTarget,
                                    "is-range": true,
                                  },
                                  on: {
                                    onChange: _vm.onChangeRange,
                                    onClose: function () {
                                      return _vm.hideDateRange(
                                        _vm.dateRangeType
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              3462218844
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }